import Repository from "./Repository";
import Establishment from "../class/accounting/Establishment";
import LegalInformation from "../class/invoice/LegalInformation";
import Stats from "../class/accounting/Stats";
import UrlParamsManager, {
    FilterArgument,
    FilterLogLevel, FilterOperator,
    FilterParam,
    FilterType
} from "horizon-js-sdk/lib/UrlParamsManager";
import {Router} from "horizon-js-front-sdk/lib/Router";


export default class EstablishmentRepository extends Repository {
    constructor() {
        super();
    }

    //TODO: change url correctly
    private insertParam(key: string, value: string) {
        let url = new URL(window.location.href);
        if(url.searchParams.get(key)!==value){
            url.searchParams.set(key, value);
            window.location.href = url.toJSON();
        }
    }

    get_stats(establishmentUid?: Uuid, params: FilterParam[]=[], args: FilterArgument[]=[]): Promise<Stats> {
        let waitingPromises: Promise<any>[] = [];
        if (establishmentUid === undefined) {
            waitingPromises.push(this.get_current_establishment_uid().then((establishmentUidFromRepository: Uuid) => {
                establishmentUid = establishmentUidFromRepository;
            }));
        }

        let manager : UrlParamsManager = new UrlParamsManager({
            logLevel: FilterLogLevel.ERRORS,
            filterConfig: [{
                nom: 'issuedDate',
                type: [
                    FilterType.STRING,
                ],
                operators: [
                    FilterOperator.EQUALS,
                    FilterOperator.GREATER_OR_EQUAL,
                    FilterOperator.LESS_OR_EQUAL
                ]
            }, {
                nom: 'creationDate',
                type: [
                    FilterType.STRING,
                ],
                operators: [
                    FilterOperator.EQUALS,
                    FilterOperator.GREATER_OR_EQUAL,
                    FilterOperator.LESS_OR_EQUAL
                ]
            }, {
                nom: 'customerUid',
                type: [
                    FilterType.STRING,
                ],
                operators: [
                    FilterOperator.EQUALS,
                ]
            }]
        });

        manager.addParams(params, args);

        return Promise.all(waitingPromises).then(() => {
            return this.request(this.apiUrl + 'Establishments/' + establishmentUid + '/Stats/' + manager.buildUrlParams()).then(function (JSONStats: any) {
                return new Stats(JSONStats);
            });
        });
    }

    getProductSellsStats(establishmentUid?: Uuid, params: FilterParam[]=[], args: FilterArgument[]=[]) {
        let waitingPromises: Promise<any>[] = [];
        if (establishmentUid === undefined) {
            waitingPromises.push(this.get_current_establishment_uid().then((establishmentUidFromRepository: Uuid) => {
                establishmentUid = establishmentUidFromRepository;
            }));
        }

        let manager : UrlParamsManager = new UrlParamsManager({
            logLevel: FilterLogLevel.ERRORS,
            filterConfig: [{
                nom: 'creationDate',
                type: [
                    FilterType.STRING,
                ],
                operators: [
                    FilterOperator.EQUALS,
                    FilterOperator.GREATER_OR_EQUAL,
                    FilterOperator.LESS_OR_EQUAL
                ]
            }]
        });

        manager.addParams(params, args);

        return Promise.all(waitingPromises).then(() => {
            return this.request(this.apiUrl + 'Establishments/' + establishmentUid + '/Stats/ProductSells/' + manager.buildUrlParams()).then((JSONStats: any) => {
                return JSONStats;
            });
        });
    }

    getEstablishmentFreePathname() {
        let pathname = window.location.pathname;
        let splitted = pathname.split('/').filter(Boolean);
        if(splitted[0] === 'etablissement') {
            splitted.splice(0, 2);
        }
        return '/' + splitted.join('/');
    }

    public static getUrlEstablishmentUid(): string|null {
        let matches = Router.getMainRouter()?.lastRouteRegexMatches;
        if(matches) {
            let establishment_url_uid = matches[1];
            if(establishment_url_uid) {
                return establishment_url_uid;
            }
        }
        return null;
    }

    public static getPathNameWithEstablishmentUid(pathname: string) {
        let fullPathname = window.location.pathname;
        let splitted = fullPathname.split('/').filter(Boolean);
        if(splitted[0] === 'etablissement') {
            splitted.splice(2);
        }
        return '/' + splitted.join('/') + pathname;
    }

    changeUrlEstablishmentUid(establishmentUid: string) {
        let pathname = this.getEstablishmentFreePathname();
        Router.getMainRouter()?.changePage('/etablissement/' + establishmentUid + pathname)
        history.replaceState({}, 'page', window.location.origin + '/etablissement/' + establishmentUid + pathname)
    }

    public get_current_establishment_uid(): Promise<Uuid> {
        let establishment_url_uid = EstablishmentRepository.getUrlEstablishmentUid();
        if(establishment_url_uid) {
            return Promise.resolve(establishment_url_uid);
        }

        return this.getAll().then((establishments: Establishment[]) => {
            console.log('matches[1]');
            if (establishments.length > 0) {
                // Verify establishment_url_uid again since getAll is async
                let establishment_url_uid = EstablishmentRepository.getUrlEstablishmentUid();
                if(!establishment_url_uid) {
                    this.changeUrlEstablishmentUid(establishments[0].uid);
                }

                return establishments[0].uid;
            } else {
                return Promise.reject('Error : Aucun établissement trouvé. | class EstablishmentRepository | function get()')
            }
        });
    }

    public getCurrent(establishmentUid?: Uuid):Promise<Establishment> {
        let waitingPromises: Promise<any>[] = [];
        if (establishmentUid === undefined) {
            waitingPromises.push(this.get_current_establishment_uid().then((establishmentUidFromRepository: Uuid) => {
                establishmentUid = establishmentUidFromRepository;
            }));
        }

        return Promise.all(waitingPromises).then(() => {
            return this.request(this.apiUrl + 'Establishments/' + establishmentUid + '/', null, "GET", true).then(function (JSONEstablishment: any) {
                return new Establishment(JSONEstablishment);
            });
        });
    }

    public update(establishment: Establishment) {
        return this.request(this.apiUrl + 'Establishments/' + establishment.uid + '/', establishment.exportToJson(), 'PUT', true).then((JSONEstablishment: any) => {
            return new Establishment(JSONEstablishment);
        });
    }

    public getAll(): Promise<Array<Establishment>> {
        return this.request(this.apiUrl + 'Establishments/', null, "GET", true).then(function (JSONEstablishments: any) {
            let establishments: Array<Establishment> = [];
            for (let JSONEstablishment of JSONEstablishments) {
                establishments.push(new Establishment(JSONEstablishment));
            }
            return establishments;
        });
    }

}
